import { EsriMap } from '../map';

export interface IMapBaseOverlayOptions {
  id?: string;
  zIndex?: number;
  opacity?: number;
  clickable?: boolean;
  map?: EsriMap;
}
